import { render, staticRenderFns } from "./HelpScreenItem.vue?vue&type=template&id=a87c3482"
import script from "./HelpScreenItem.vue?vue&type=script&lang=js"
export * from "./HelpScreenItem.vue?vue&type=script&lang=js"
import style0 from "./HelpScreenItem.vue?vue&type=style&index=0&id=a87c3482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports